import { useIsStaff } from '@vimeo/core/hooks/use-is-staff/useIsStaff';
import { SubjectKeyTypes, useEppoAssignment, VariationTypes } from '@vimeo/eppo';
import { useViewer } from '@vimeo/viewer';

export const useNewCtaAssignment = () => {
  const viewer = useViewer();
  const currentUserIsStaff = useIsStaff();

  // get user and team information
  const user = viewer?.user;
  const userId = user?.id;
  const teamUser = viewer?.teamUser;
  const ownerId = teamUser?.ownerId;
  const cuid = (ownerId || userId) ?? 0;

  // get additional data for the experiment
  const isEnterprise = !!(teamUser
    ? teamUser?.accountType === 'enterprise'
    : user?.capabilities?.hasEnterprise);
  const isFree = teamUser ? !teamUser?.hasPaid : !user?.capabilities?.hasPaid;
  const isStaff = (!teamUser || ownerId === userId) && currentUserIsStaff;

  const { assignment } = useEppoAssignment({
    flagKey: 'top-nav-new-cta',
    subject: {
      key: cuid,
      keyType: SubjectKeyTypes.TEAM_OWNER_ID,
      additionalData: {
        isEnterprise,
        isFree,
        isStaff,
      },
    },
    assignmentType: VariationTypes.BOOLEAN,
    defaultAssignment: false,
    disabled: !user && !teamUser,
  });

  return assignment;
};
